import { Injectable } from '@angular/core';
import { NedermanUserSearchAssign, NedermanUserSearchInput, NedermanUserSearchOrderBy } from 'app/backend/api';

@Injectable()
export class NedermanUserParams {

  public searchValue = '';
  public selectedCompany = '';
  public assignFilter: NedermanUserSearchAssign = NedermanUserSearchAssign.Assigned;
  public orderBy: NedermanUserSearchOrderBy = NedermanUserSearchOrderBy.Name;
  public selectedApplication = '';

  public query: NedermanUserSearchInput = {
    search: '',
    company: '',
    hostNedermanId: '',
    applicationId: '',
    assign: NedermanUserSearchAssign.Assigned,
    orderBy: NedermanUserSearchOrderBy.Name,
    offset: 0
  };

  changeAssign() {
    this.query.company = '';
    this.query.hostNedermanId = '';
    this.query.applicationId = '';
    this.query.offset = 0;
    this.selectedApplication = '';
    this.orderBy = NedermanUserSearchOrderBy.Name;
    this.selectedCompany = '';
  }
}
